export const PRECIO_SOLES = {
    venta: 4.1,
    compra: 3.904,
};
